module.exports = __webpack_public_path__ + "static/media/ladakhwebp.3ba6ea05.webp";